(() => {
  const initLineCarousels = () => {
    document.querySelectorAll('.mb-lines-carousel-shell').forEach((shell) => {
      if (shell.dataset.mbCarouselReady === 'true') return;
      shell.dataset.mbCarouselReady = 'true';

      const carousel = shell.querySelector('[data-mb-lines-carousel]');
      const previousButton = shell.querySelector('[data-mb-lines-prev]');
      const nextButton = shell.querySelector('[data-mb-lines-next]');
      if (!carousel) return;

      let offset = 0;
      let pointerId = null;
      let pointerStartX = 0;
      let pointerStartY = 0;
      let pointerStartTime = 0;
      let pointerLastX = 0;
      let pointerStartOffset = 0;
      let pointerStartVisualOffset = 0;
      let pointerDirection = null;
      let dragged = false;
      let suppressClick = false;
      let wheelSnapTimer = null;
      let wheelStartOffset = 0;
      let wheelStartVisualOffset = 0;
      let wheelDelta = 0;
      let wheelActive = false;

      const getMaximumOffset = () => Math.max(0, carousel.scrollWidth - shell.clientWidth);

      const render = (animate = true) => {
        offset = Math.min(Math.max(offset, 0), getMaximumOffset());
        carousel.classList.toggle('is-dragging', !animate);
        carousel.style.transform = `translate3d(${-offset}px, 0, 0)`;

        if (previousButton) previousButton.disabled = offset <= 1;
        if (nextButton) nextButton.disabled = offset >= getMaximumOffset() - 1;
      };

      const getCardStep = () => {
        const firstCard = carousel.querySelector('.mb-lines-card, .mb-model-card, .mb-physio-card');
        const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : carousel.clientWidth * 0.8;
        const gap = parseFloat(window.getComputedStyle(carousel).columnGap || 0);
        return cardWidth + gap;
      };

      const syncOffsetFromRenderedPosition = () => {
        const transform = window.getComputedStyle(carousel).transform;
        const match = transform.match(/^matrix(3d)?\((.+)\)$/);
        if (!match) return;

        const values = match[2].split(',').map(Number);
        const translateX = match[1] ? values[12] : values[4];
        if (Number.isFinite(translateX)) offset = -translateX;
      };

      const snapToClosestCard = () => {
        const cardStep = getCardStep();
        if (!cardStep) return;

        offset = Math.round(offset / cardStep) * cardStep;
      };

      const getAdjacentCardOffset = (direction, fromOffset = offset) => {
        const cardStep = getCardStep();
        if (!cardStep) return fromOffset;

        const ratio = fromOffset / cardStep;
        const targetIndex = direction > 0
          ? Math.floor(ratio + 0.001) + 1
          : Math.ceil(ratio - 0.001) - 1;

        return targetIndex * cardStep;
      };

      const scrollByPage = (direction) => {
        offset = getAdjacentCardOffset(direction);
        render(true);
      };

      previousButton?.addEventListener('click', () => scrollByPage(-1));
      nextButton?.addEventListener('click', () => scrollByPage(1));

      carousel.addEventListener(
        'wheel',
        (event) => {
          const horizontalDelta = event.shiftKey ? event.deltaY : event.deltaX;

          if (Math.abs(horizontalDelta) <= Math.abs(event.deltaY) && !event.shiftKey) return;

          event.preventDefault();

          if (!wheelActive) {
            syncOffsetFromRenderedPosition();
            wheelStartOffset = offset;
            wheelStartVisualOffset = offset;
            wheelDelta = 0;
            wheelActive = true;
          }

          wheelDelta += horizontalDelta;
          offset = wheelStartVisualOffset + wheelDelta;
          render(false);

          window.clearTimeout(wheelSnapTimer);
          wheelSnapTimer = window.setTimeout(() => {
            if (Math.abs(wheelDelta) > 12) {
              offset = getAdjacentCardOffset(wheelDelta > 0 ? 1 : -1, wheelStartOffset);
            } else {
              snapToClosestCard();
            }

            wheelActive = false;
            wheelDelta = 0;
            render(true);
          }, 160);
        },
        { passive: false }
      );

      carousel.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        window.clearTimeout(wheelSnapTimer);
        wheelActive = false;
        wheelDelta = 0;
        syncOffsetFromRenderedPosition();
        pointerStartOffset = offset;
        pointerStartVisualOffset = offset;
        render(false);

        pointerId = event.pointerId;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        pointerStartTime = performance.now();
        pointerLastX = event.clientX;
        pointerDirection = null;
        dragged = false;
      });

      carousel.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;

        const deltaX = event.clientX - pointerStartX;
        const deltaY = event.clientY - pointerStartY;

        if (!pointerDirection && Math.max(Math.abs(deltaX), Math.abs(deltaY)) > 8) {
          pointerDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
        }

        if (pointerDirection !== 'horizontal') return;

        event.preventDefault();
        if (!carousel.hasPointerCapture(pointerId)) carousel.setPointerCapture(pointerId);
        dragged = true;
        pointerLastX = event.clientX;
        offset = pointerStartVisualOffset - deltaX;
        render(false);
      });

      const finishPointer = (event) => {
        if (event.pointerId !== pointerId) return;

        const wasDragged = dragged;
        if (carousel.hasPointerCapture(pointerId)) carousel.releasePointerCapture(pointerId);
        pointerId = null;
        pointerDirection = null;
        dragged = false;

        if (wasDragged) {
          const swipeDistance = pointerLastX - pointerStartX;
          const swipeDuration = Math.max(1, performance.now() - pointerStartTime);
          const swipeVelocity = Math.abs(swipeDistance) / swipeDuration;
          const swipeThreshold = Math.min(64, Math.max(28, getCardStep() * 0.12));
          const isQuickFlick = Math.abs(swipeDistance) >= 12 && swipeVelocity >= 0.18;

          if (Math.abs(swipeDistance) >= swipeThreshold || isQuickFlick) {
            offset = getAdjacentCardOffset(swipeDistance < 0 ? 1 : -1, pointerStartOffset);
          } else {
            snapToClosestCard();
          }
        }

        render(true);

        if (wasDragged) {
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 0);
        }
      };

      carousel.addEventListener('pointerup', finishPointer);
      carousel.addEventListener('pointercancel', finishPointer);
      carousel.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        },
        true
      );

      carousel.addEventListener('dragstart', (event) => event.preventDefault());

      window.addEventListener('resize', () => render(false));
      render(false);
    });
  };

  document.addEventListener('DOMContentLoaded', initLineCarousels);
  document.addEventListener('shopify:section:load', initLineCarousels);
})();
